import { baseURL as envBaseURL, escalationTeamMember as envEscalationTeam } from './env';

let token = "";

export const setToken = (newToken) => {
  token = newToken;
  try {
    if (typeof window !== "undefined" && newToken) {
      localStorage.setItem("token", newToken);
    }
  } catch (_) {}
};

export const getToken = () => {
  if (token) return token;
  if (typeof window !== "undefined") {
    const fromUrl = new URLSearchParams(window.location.search).get("token");
    if (fromUrl) return fromUrl;
    try {
      const fromLocal = localStorage.getItem("token");
      if (fromLocal) return fromLocal;
    } catch (_) {}
  }
  return "";
};

export const baseURL = envBaseURL;

export const GOOGLE_OAUTH_CLIENT_ID =
  "95993965258-rklc6lesppdcqda08sli02fk4rv3h296.apps.googleusercontent.com";

export const escalationTeamMember = envEscalationTeam;

